export default {
    type: String,
    default: '50',
    validator: (value) => {
        return ['25', '33', '50', '100', 'full'].includes(value);
    },
};
